var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { staticClass: "mb-3" },
        [
          _c(
            "validation-observer",
            { ref: "validator" },
            [
              _c(
                "b-form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.createOrUpdate($event)
                    }
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "reporting_channel.deadline_config.handling_status"
                                ),
                                "label-for": "handling_status"
                              }
                            },
                            [
                              _c(
                                "v-select",
                                {
                                  attrs: {
                                    options: _vm.handlingStatusOptions,
                                    reduce: function(option) {
                                      return option.key
                                    },
                                    "get-option-label": function(option) {
                                      return option ? option.label : ""
                                    },
                                    placeholder: "Selecione a situação"
                                  },
                                  model: {
                                    value: _vm.model.handling_status,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "handling_status",
                                        $$v
                                      )
                                    },
                                    expression: "model.handling_status"
                                  }
                                },
                                [
                                  _c("template", { slot: "no-options" }, [
                                    _c("span", [
                                      _vm._v("Nenhuma situação encontrada")
                                    ])
                                  ])
                                ],
                                2
                              ),
                              _vm.errors.handling_status
                                ? _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(
                                      _vm._s(_vm.errors.handling_status[0])
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "reporting_channel.deadline_config.deadline_days"
                                ),
                                "label-for": "deadline_days"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "deadline_days",
                                  type: "number",
                                  min: "1",
                                  state: _vm.errors.deadline_days ? false : null
                                },
                                model: {
                                  value: _vm.model.deadline_days,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "deadline_days",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "model.deadline_days"
                                }
                              }),
                              _vm.errors.deadline_days
                                ? _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(_vm.errors.deadline_days[0]))
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "reporting_channel.deadline_config.is_business_days"
                                ),
                                "label-for": "is_business_days"
                              }
                            },
                            [
                              _c("b-form-radio-group", {
                                attrs: {
                                  id: "is_business_days",
                                  options: _vm.deadlineTypeOptions,
                                  name: "is_business_days"
                                },
                                model: {
                                  value: _vm.model.is_business_days,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "is_business_days", $$v)
                                  },
                                  expression: "model.is_business_days"
                                }
                              }),
                              _vm.errors.is_business_days
                                ? _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(
                                      _vm._s(_vm.errors.is_business_days[0])
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-end gap-2 mt-3" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            disabled: !_vm.validateForm
                          },
                          on: { click: _vm.createOrUpdate }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.editingId
                                  ? _vm.$t("action.save")
                                  : _vm.$t("action.create")
                              ) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-secondary" },
                          on: { click: _vm.resetForm }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("action.clear") || "Limpar") +
                              " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.service && _vm.workflowConfigId
        ? _c("Grid", {
            ref: "grid",
            attrs: {
              service: _vm.service,
              route_name: "handling_status_configuration_index",
              route_grid_path: "grid",
              defaultOrderColumn: "id",
              defaultOrderDirection: "desc",
              forceFilters: { workflow_config_id: _vm.workflowConfigId },
              css_formats: {
                handling_status: function(status, model) {
                  if (status && status.color) {
                    return "badge badge-glow badge-" + status.color
                  }
                  return ""
                }
              },
              column_formats: {
                handling_status: function(val) {
                  return val && val.label ? val.label : val || ""
                }
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "gridThead",
                  fn: function() {
                    return [
                      _c("vs-th", { key: "id", attrs: { "sort-key": "id" } }, [
                        _vm._v("ID")
                      ]),
                      _c(
                        "vs-th",
                        {
                          key: "handling_status_label",
                          attrs: { "sort-key": "handling_status" }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "reporting_channel.deadline_config.handling_status"
                              )
                            )
                          )
                        ]
                      ),
                      _c(
                        "vs-th",
                        {
                          key: "deadline_days",
                          attrs: { "sort-key": "deadline_days" }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "reporting_channel.deadline_config.deadline_days"
                              )
                            )
                          )
                        ]
                      ),
                      _c(
                        "vs-th",
                        {
                          key: "deadline_type_label",
                          attrs: { "sort-key": "is_business_days" }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "reporting_channel.deadline_config.is_business_days"
                              )
                            )
                          )
                        ]
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "gridData",
                  fn: function(props) {
                    return _vm._l(props.data, function(tr, indextr) {
                      return _c(
                        "vs-tr",
                        { key: indextr, attrs: { data: tr } },
                        [
                          _c("vs-td", { key: "id" }, [
                            _c("div", [_vm._v(_vm._s(tr.id))])
                          ]),
                          _c("vs-td", { key: "handling_status_label" }, [
                            _c(
                              "div",
                              {
                                class: _vm.getHandlingStatusCss(
                                  tr.handling_status
                                ),
                                style: _vm.getHandlingStatusStyle(
                                  tr.handling_status
                                )
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getHandlingStatusLabel(
                                        tr.handling_status
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]),
                          _c("vs-td", { key: "deadline_days" }, [
                            _c("div", [_vm._v(_vm._s(tr.deadline_days))])
                          ]),
                          _c("vs-td", { key: "deadline_type_label" }, [
                            _c("div", [_vm._v(_vm._s(tr.deadline_type_label))])
                          ]),
                          _c(
                            "vs-td",
                            [
                              _vm._t(
                                "actions",
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-full flex gap-2 justify-end"
                                    },
                                    [
                                      _c("feather-icon", {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName: "v-permission",
                                            value:
                                              "reporting_channel_handling.configuration.deadlines.edit",
                                            expression:
                                              "\n                  `reporting_channel_handling.configuration.deadlines.edit`\n                "
                                          },
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip.top",
                                            value: {
                                              content: "Editar prazo",
                                              delay: { show: 100, hide: 100 }
                                            },
                                            expression:
                                              "{\n                  content: 'Editar prazo',\n                  delay: { show: 100, hide: 100 }\n                }",
                                            modifiers: { top: true }
                                          }
                                        ],
                                        staticClass:
                                          "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                                        attrs: { icon: "EditIcon" },
                                        on: {
                                          click: function($event) {
                                            return _vm.edit(tr.id)
                                          }
                                        }
                                      }),
                                      _c("feather-icon", {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName: "v-permission",
                                            value:
                                              "reporting_channel_handling.configuration.deadlines.delete",
                                            expression:
                                              "\n                  `reporting_channel_handling.configuration.deadlines.delete`\n                "
                                          },
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip.top",
                                            value: {
                                              content: "Excluir prazo",
                                              delay: { show: 100, hide: 100 }
                                            },
                                            expression:
                                              "{\n                  content: 'Excluir prazo',\n                  delay: { show: 100, hide: 100 }\n                }",
                                            modifiers: { top: true }
                                          }
                                        ],
                                        staticClass:
                                          "h-5 w-5 mb-1 mr-1 stroke-current text-danger",
                                        attrs: { icon: "Trash2Icon" },
                                        on: {
                                          click: function($event) {
                                            return _vm.destroy(tr.id)
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                {
                                  row: tr,
                                  data: props.data,
                                  indextr: indextr,
                                  methods: {
                                    edit: props.edit,
                                    destroy: props.destroy
                                  }
                                }
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    })
                  }
                }
              ],
              null,
              true
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }